/**
 * Created by .xx16 on 1/9/2016.
 */

export default class SimpleCache {
    constructor(targetClass, initialCapacity) {
        this._targetClass = targetClass;
        /** @type {Array} */
        this._instances = [];

        for (let i = 0; i < initialCapacity; i++) {
            this._instances.push(this.getNewInstance());
        }
    }

    get() {
        if (this._instances.length) {
            return this._instances.shift();
        } else {
            return this.getNewInstance();
        }
    }

    set(instance) {
        this._instances.push(instance);
    }

    clear() {
        this._instances = [];
        this._targetClass = null;
    }

    getNewInstance() {
        return (new this._targetClass());
    }
}
